function compareTo() {
    return {
        require: "ngModel",
        scope: {
            otherViewValue: "=compareTo"
        },
        link: function(scope, element, attributes, ngModel) {
            ngModel.$validators.compareTo = function(modelValue) {
                return (scope.otherViewValue || modelValue) ? modelValue == scope.otherViewValue : true;
            };
            scope.$watch("otherViewValue", function() {
                ngModel.$validate();
            });
        }
    };
}

export default angular.module('compareTo', []).directive('compareTo', compareTo).name;



/** WEBPACK FOOTER **
 ** D:/server/Apache24/htdocs/hmr/app/HMRX_App/scripts/src/app/directives/compareTo.directive.js
 **/